import '../Profile.css'
import { Box } from "@mui/material"
import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import { AppContext } from "contexts/AppContext";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { callAPI } from "utils/API";
import ContentSmall from 'components/elements/ContentSmall';
import Headline6 from 'components/elements/Headline6';

const CouponsPage = () => {
    const { styleGuide } = useContext(AppContext)
    const [loading, setLoading] = useState(true)
    const [coupons, setCoupons] = useState([])

    const fetchCoupons = async () => {
        let coupons = await callAPI(`/user/coupons`, 'GET')
        if (!coupons || !coupons.length){
            setCoupons([])
            setLoading(false)
        }
        
        coupons = coupons.map(coupon => ({...coupon, timeInsert: moment(coupon.timeInsert).format("DD.MM.YYYY"), expirationTime: moment(coupon.expirationTime).format("YYYY-MM-DD HH:mm:ss")}))

        setCoupons(coupons)
        setLoading(false)
    }

    useEffect(() => {
        fetchCoupons()
    }, [])

    return (
        <Box flex={1} display={'flex'} flexDirection={'column'} gap={6} marginBottom={10}>
            <Box flex={1} display={'flex'} flexDirection={'column'} gap={2}>
                <Headline5
                    translationKey="_COUPON_LIST_HEADLINE_"
                    fallbackText="Dine vouchers"
                />
                {loading
                    ?
                    <Box display={'flex'} flex={1} justifyContent={'center'} marginTop={2}>
                        <CircularIndeterminate />
                    </Box>
                    : !coupons.length
                        ?
                        <Box
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "1rem",
                                border: `1px solid ${styleGuide.color4}`,
                                borderRadius: "14px",
                                padding: 40,
                            }}
                        >
                            <Headline5
                                translationKey="_NO_COUPONS_HEADLINE_"
                                fallbackText="Du har ingen vouchers endnu"
                                style={{textAlign: 'center'}}
                            />
                            <ContentNormal
                                translationKey="_NO_COUPONS_TEXT_"
                                fallbackText="Efter du har aktiveret en voucher i shoppen vil det blive vist her."
                                style={{textAlign: 'center'}}
                            />
                        </Box>
                        :
                        <Box display={'flex'} flexWrap={'wrap'} gap={4}>
                            {coupons.map((coupon) => (
                                <Coupon coupon={coupon} />
                            ))}
                        </Box>
                }
            </Box>
        </Box>
    );
}

const Coupon = (props) => {
    const { coupon } = props
    const { styleGuide } = useContext(AppContext)
    const isExpired = new Date(coupon.expirationTime) - new Date() < 0

    return (
        <Box
            key={coupon.CouponID}
            border={`1px solid ${styleGuide.color4}`}
            borderRadius={'14px'}
            width={280}
            padding={2}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            gap={2}
            sx={{opacity: isExpired ? 0.5 : 1}}
        >
            <Box key={coupon.CouponID} display={'flex'} flexDirection={'column'} gap={2}>
                <img
                    src={coupon.product?.images[0]?.imageOptimizedSourceMedium}
                    width={246}
                    height={332}
                />

                <Headline6>
                    {coupon.product.elementTitle}
                </Headline6>
            </Box>

            <Box display={'flex'} flexDirection={'column'} gap={2}>
                {!!coupon.expirationTime &&
                    <CouponCountdown expirationTime={coupon.expirationTime} />
                }

                <Box display={'flex'} gap={1}>
                    <ContentSmall
                        translationKey="_COUPON_ACTIVATED_LABEL_"
                        fallbackText="Aktiveret d."
                        style={{color: styleGuide.color6}}
                    />
                    <ContentSmall style={{color: styleGuide.color6}}>
                        {coupon.timeInsert}
                    </ContentSmall>
                </Box>
            </Box>
        </Box>
    )
}

function CouponCountdown({ expirationTime }) {
    const { styleGuide } = useContext(AppContext)

    const calculateTimeLeft = () => {
        const difference = new Date(expirationTime) - new Date()

        return {
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
            total: difference,
        }
    }

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft())
        }, 1000);

        return () => clearInterval(timer)
    }, [])

    if (timeLeft.total < 0) {
        return (
            <Headline6
                style={{ color: styleGuide.color5 }}
                translationKey="_COUPON_EXPIRED_"
                fallbackText="Udløbet"
            />
        )
    }

    return (
        <Box display={'flex'} gap={0.5}>
            <Headline6
                style={{ color: styleGuide.color8 }}
                translationKey="_COUPON_VALID_FOR_"
                fallbackText="Gyldig i"
            />
            <Headline6 style={{ color: styleGuide.color8 }}>
                {timeLeft.hours * 60 + timeLeft.minutes}:{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}
            </Headline6>
        </Box>
    );
}

export default CouponsPage